import usePassportMemberStatuses from '@/hooks/approval/usePassportMemberStatuses';

const EMPTY_SET = new Set<string>();

/**
 * passportId 목록의 휴직 여부를 서버 기준으로 판정.
 * 퇴사 판정(useDeactivatedUsers)과 SWR 키·응답 캐시를 공유하므로, 두 훅을 같은
 * id 목록으로 함께 써도 호출은 사람당 한 번이고 오류 재시도도 한 번뿐이다.
 *
 * 휴직은 상신을 막는 상태가 아니라 표시 전용이라, 퇴사와 달리 판정 도착 여부를
 * 밖으로 내보내지 않는다. 응답 전이나 오류면 배지가 안 뜰 뿐이다.
 */
const useOnLeaveUsers = (passportIds: string[]) => {
  const { data } = usePassportMemberStatuses(passportIds);

  return { onLeaveIds: data?.onLeaveIds ?? EMPTY_SET };
};

export default useOnLeaveUsers;
